<template>
  <div class="logo-wrapper">
    <img class="logo" v-if="logoSrc" :src="'/images/'+logoSrc" v-bind:alt="currentCompany.name" >
    <!-- <img class="logo" src="/images/CHL_Logo.png"> -->
    <div class="tagline">{{ currentCompany.name }} {{ $t("logo.tagLine") }}</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Logo',
  data () {
    return {
      errorMessage: '',
      currentCompany: { logo: 'CHL_Logo.png', logoDark: '', name: 'CHL', short: 'CHL' }
    }
  },
  computed: {
    ...mapGetters(['theme']),
    logoSrc () {
      if (this.theme === 'dark' && this.currentCompany.logoDark) {
        return this.currentCompany.logoDark
      }
      return this.currentCompany.logo || null
    }
  },
  mounted () {
    // TODO: not working seems it needs auth
    this.loadCompanyValues()
  },
  methods: {
    loadCompanyValues () {
      // this.currentCompany = { logo: 'CHL_Logo.png', name: 'Clever Home Labs' }
      this.$store.dispatch('getCompanyData')
        .then(() => {
          /* eslint-disable no-console */
          console.log('Logo')
          this.currentCompany = this.$store.getters.company
          /* eslint-disable no-console */
          console.log(this.currentCompany)
        })
        .catch(() => {
          /* eslint-disable no-console */
          console.log('could not get company data')
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.logo-wrapper {
  text-align: center;
  margin-bottom: 40px;

  .tagline {
    line-height: 180%;
    font-weight: 700;
    color: #666;
  }

  .logo {
    max-width: 218px;
    margin: 0 auto;
  }

  .smallText {
        font-size: 9px;
        font-weight: 100;
    }
}
</style>
